import type { Reducer, UnknownAction } from '@reduxjs/toolkit';
import type { CommonState } from './selectors/commonSelectors.ts';

export function sessionReducer<State extends CommonState>(reducer: Reducer<State>): Reducer<State> {
  return (state: State | undefined, action: UnknownAction) => {
    const next = reducer(state, action);
    if (!state || (state.auth.accessToken === next.auth.accessToken
      && state.auth.user?.sub === next.auth.user?.sub
      && state.auth.user?.portal === next.auth.user?.portal)) return next;
    const initial = reducer(undefined, { type: 'session/reset' });
    return { ...initial, auth: next.auth, app: next.app, theme: next.theme };
  };
}